import { IValidationError } from './interfaces/ValidationError';

interface IParams {
  value: string | undefined,
  length: number,
  fieldName: string,
  fieldCaption?: string,
}

const getDefaultMessage = (params: { fieldCaption?: string, length: number }) => {
  return `${ params.fieldCaption || 'Field' } may not contain more than ${ params.length } characters`;
};

export const validateMaxLength = (params: IParams, getMessage = getDefaultMessage): IValidationError => {
  if (params.value && params.value.trim().length > params.length) {
    return {
      [params.fieldName]: getMessage({
        fieldCaption: params.fieldCaption,
        length: params.length,
      }),
    };
  }
  // @ts-ignore
  return null;
};
